import { useState } from "react";
import { NaviiLogo } from "./NaviiLogo";

type NaviiIconProps = {
  size?: number;
  performSearch?: () => Promise<void> | void;
  isSearching?: boolean;
  className?: string;
};

/** Backwards-compatible clickable wrapper for existing search usages. */
export function NaviiIcon({
  size = 48,
  performSearch,
  isSearching: controlledIsSearching,
  className,
}: NaviiIconProps) {
  const [internalIsSearching, setInternalIsSearching] = useState(false);
  const isSearching = controlledIsSearching ?? internalIsSearching;

  const runSearch = async () => {
    if (!performSearch || isSearching) return;
    setInternalIsSearching(true);
    try {
      await performSearch();
    } finally {
      setInternalIsSearching(false);
    }
  };

  return (
    <div
      className="navii-search"
      onClick={runSearch}
      style={{
        width: size,
        height: size,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        cursor: performSearch ? "pointer" : "default",
      }}
    >
      <NaviiLogo size={size} isSearching={isSearching} className={className} />
    </div>
  );
}
